import React from 'react';
import { Navigate } from 'react-router-dom';
import { FaUsers, FaChartBar, FaCalendarAlt, FaEnvelope } from 'react-icons/fa';
import PageChrome from '../../components/layout/PageChrome';
import InfoCard from '../../components/cards/InfoCard';
import EventCard from '../../components/cards/EventCard';
import Carousel from '../../components/ui/Carousel';
import graduateStudents from '../../cms/graduate-students.json';
import RichText from '../../components/ui/RichText';
import '../../css/pages/GraduateStudents.css';

const ICONS = {
  users: <FaUsers />,
  chart: <FaChartBar />,
  calendar: <FaCalendarAlt />,
  envelope: <FaEnvelope />,
};

const renderCardContent = (card) => (
  <div>
    <RichText value={card.content} />
    {(card.bullets || []).length > 0 && (
      <ul>
        {card.bullets.map((bullet, i) => (
          <li key={i}>{bullet}</li>
        ))}
      </ul>
    )}
    {card.linkText && card.linkUrl && (
      <a href={card.linkUrl} className="mailing-list-link">
        {card.linkText}
      </a>
    )}
  </div>
);

const GraduateStudents = () => {
  // Check if page is enabled - redirect to 404 if not
  if (!graduateStudents.enabled) {
    return <Navigate to="/404" replace />;
  }

  const renderEventCard = (event) => (
    <EventCard key={event.id} event={event} />
  );

  return (
    <div>
      <PageChrome title={graduateStudents.title} subtitle={graduateStudents.subtitle}>
        <div className="graduate-students-content">
          
          {/* Community Information Section */}
          <section className="community-info-section">
            <h2>{graduateStudents.aboutSectionTitle}</h2>

            {(graduateStudents.aboutCards || []).map((card, i) => (
              <InfoCard
                key={i}
                title={card.title}
                icon={ICONS[card.icon] || <FaUsers />}
                content={renderCardContent(card)}
              />
            ))}
          </section>

          {/* Events Section */}
          <section className="events-section">
            <h2>{graduateStudents.eventsSectionTitle}</h2>
            <RichText value={graduateStudents.eventsDescription} className="events-description" />
            
            <Carousel
              items={graduateStudents.events || []}
              renderItem={renderEventCard}
              itemsPerView={3}
              spaceBetween={20}
            />
          </section>

          {/* Communication Section */}
          <section className="communication-section">
            <h2>{graduateStudents.stayConnectedTitle}</h2>

            {(graduateStudents.connectCards || []).map((card, i) => (
              <InfoCard
                key={i}
                title={card.title}
                icon={ICONS[card.icon] || <FaEnvelope />}
                content={renderCardContent(card)}
              />
            ))}
          </section>

        </div>
      </PageChrome>
    </div>
  );
};

export default GraduateStudents;
